import CommonErrorPage from "./common-error-page";
import { useGlobalError } from "../../utils/errorContext";

import { retryCurrentPage } from "../../utils/retryService";
import { useAuthLogout } from "../../auth/authLogout";

const GlobalErrorComponent = () => {
  const { error, clearError } = useGlobalError();
  const { appLogout } = useAuthLogout();
  console.log("GlobalErrorComponent Rendered with error:", error);
  if (!error) return null;

  return (
    <>
      <CommonErrorPage
        code={error.code}
        title={error.title}
        description={error.description}
        image={error.image}
        content={error.content}
        content1={error.content1}
        actionLabel={error.actionLabel}
        phoneNubmer={error.phoneNubmer}
        mailId={error.mailId}
        onActionClick={() => {
          clearError();
          retryCurrentPage();
        }}
        goToLogin={appLogout}
      />
    </>
  );
};
export default GlobalErrorComponent;
